import { render, staticRenderFns } from "./ModalReportBug.vue?vue&type=template&id=5f8f506c&scoped=true"
import script from "./ModalReportBug.ts?vue&type=script&lang=ts&external"
export * from "./ModalReportBug.ts?vue&type=script&lang=ts&external"
import style0 from "./ModalReportBug.vue?vue&type=style&index=0&id=5f8f506c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8f506c",
  null
  
)

export default component.exports